<section id="Solutions">
    <div class="row">
        <div class="title-section">
            <h3>خدمات ما</h3>
        </div>
        <div class="body-section">
            <div class="column medium-4">
                <a target="_blank" routerLink="/services/modiriyat-sarmayeh-gozari">
                    <figure>
                        <img src="../../../assets/images/pcts_317x222_acf_cropped.png">
                        <figcaption>مدیریت سرمایه گذاری</figcaption>
                    </figure>
                </a>
            </div>
            <div class="column medium-4">
                <a target="_blank" routerLink="/investment-advice">
                    <figure>
                        <img src="../../../assets/images/conv_317x222_acf_cropped.png">
                        <figcaption>مشاوره سرمایه گذاری</figcaption>
                    </figure>
                </a>
            </div>
            <div class="column medium-4">
                <a target="_blank" href="http://abandidgah.com">
                    <figure>
                        <img src="../../../assets/images/Untitled-1-3_317x222_acf_cropped.png">
                        <figcaption>سامانه تحلیلی دیدگاه آبان</figcaption>
                    </figure>
                </a>
            </div>
        </div>
    </div>
</section>